export default "__VITE_ASSET__Cii5ysVw__"